import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inContentProcessors } from '../../canvas/injection/ContentInjector';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTools } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { createGraphicFromPopup, createGraphicFromUrl } from './GraphicCommands';
import { GraphicFromHtmlFileProcessor } from './GraphicFromHtmlFileProcessor';
import { GraphicFromImageFileProcessor } from './GraphicFromImageFileProcessor';
import { GraphicMechanics } from './GraphicMechanics';
import { graphicTool } from './GraphicTool';
import { graphicToolboxItem } from './GraphicToolboxItem';

export class GraphicPackage implements Package {

    public install = (host: PackageHost) => host
        .register(GraphicMechanics, 'singleton', 'startable')
        .plug(inContentProcessors(GraphicFromImageFileProcessor, GraphicFromHtmlFileProcessor))
        .plug(inCommands(createGraphicFromUrl, createGraphicFromPopup))
        .plug(inTools(graphicTool))
        .plug(inToolboxItems(graphicToolboxItem))
        ;
}
